// @ts-nocheck
import { setCookie } from "@insite/client-framework/Common/Cookies";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import {
    chain,
    ResetSortTypeIfNeeded,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

const productListSortTypeCookie = "productListSortType";

addToChainAfter(chain, ResetSortTypeIfNeeded, props => {
    const productsDataView = getProductsDataView(props.getState(), props.apiParameter);
    if (!productsDataView.value || !productsDataView.pagination) {
        return;
    }

    const pagination: PaginationModel = productsDataView.pagination;

    if (
        props.apiParameter.sort &&
        (props.apiParameter.sort !== productsDataView.pagination.sortType ||
            pagination.sortOptions.findIndex(so => so.sortType === props.apiParameter.sort) === -1)
    ) {
        // reset the sort to the first value
        setCookie(productListSortTypeCookie, pagination.sortOptions[0]?.sortType);
    }
});
